<template>
    <div class="mt-5 rounded border border-[#d1d5db] w-full max-w-7xl bg-white shadow">
        <div class="w-full Class Properties p-10">
            <div class="w-full h-[124px] bg-[#4361EE] rounded-lg text-center">
                <p class="pt-[15px] text-[#fff] text-[16px]">Available Points</p>
                <p class="text-[#fff] text-[48px]">{{ numberWithCommas(availableWalletAmount) }}</p>
            </div>
        </div>

        <div class="px-10 py-5 gap-10 flex flex-col">
            <div class="flex flex-col gap-2">
                <div class="font-inter-heading-15 text-content-basic-1 mb-2">Recipient Wallet</div>
                <div class="flex items-center gap-2">
                        <DesignDropdownSelect
                            v-model="selectedWalletCategorySeq" 
                            :options="walletCategoryOptions" 
                            size="LG"
                            :width="'w-60'" 
                            placeholder="Select Wallet" 
                            :useDefaultMsg="false"
                            :error="showWalletCategoryError ? walletCategoryErrorMessage : null"
                            @change="onWalletCategoryChange" />
                        <div v-if="subAdminAvailableMileage != null" class="ml-2 font-inter-heading-20 text-primary-3">
                            Available Points : {{ numberWithCommas(subAdminAvailableMileage) }} P
                        </div>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <div class="font-inter-heading-15 text-content-basic-1 mb-2">Recipient Sub-admins</div>
                <div class="flex items-center gap-5">
                        <ElementsSearchBar
                            v-model="searchInputStr"
                            :options="subAdminOptions"
                            :height12="true"
                            :width60="true"
                            :placeholder="employeePlaceholer"
                            @searchEvent="searchEmployeeData"
                            ref="employeeSearchBar"
                            :optionClickEvent="true"
                            :hasSearchButton="true" />
                </div>
            </div>
        </div>

        <div class="grid gap-4 px-10" style="grid-template-columns: 42% 3.5% 52%;">
            <div>
                <div class="w-full py-10">
                    <div class="w-full h-[1px] bg-[#D9D9D9] relative">
                        <div class="px-5 font-inter-heading-15 text-content-basic-1 bg-[#fff] absolute text-center left-[50%] translate-x-[-50%] top-[-15px] truncate">
                            Choose Sub-admin
                        </div>
                    </div>
                </div>
                <div class="h-[46.75rem] border-[#D6DDEB] border-[1px] rounded-lg overflow-hidden">
                    <div class="h-[4.25rem] flex justify-between items-center bg-[#F8F8F8] border-b-[1px]">
                        <h3 class="px-4 text-base font-medium text-slate-500 w-[3.125rem] text-center">No</h3>
                        <h3 class="py-4 text-base font-medium text-slate-500 w-[12.8125rem] text-center">Name</h3>
                        <h3 class="py-4 text-base font-medium text-slate-500 w-[12.8125rem] text-center">
                            Dept. <br />
                            & Tier
                        </h3>
                    </div>

                    <div class="overflow-auto max-h-[42.5rem]">
                        <div class="min-w-full">
                            <template v-for="(employee, index) in employees" v-bind:key="index">
                                <div class="flex justify-between items-center py-2.5"
                                    :class="{ 'bg-slate-50': index % 2 !== 0 }"
                                    @click="clickAddButton(employee)">
                                    <div class="w-[3.125rem] text-sm font-normal text-center truncate">
                                        {{ index + 1 + AccEmployeeCount }}
                                    </div>

                                    <div class="w-[12.8125rem] flex items-center gap-2 px-4">
                                        <StatusCircle :status-code="employee.employeeStatus" class="mt-1" />
                                        <div class="ml-1 flex-1 text-base font-bold line-clamp-2">
                                            {{ employee.employeeName }}
                                        </div>
                                    </div>

                                    <div class="w-[12.8125rem] text-sm font-normal text-center px-4">
                                        <div class="flex-1 text-base">
                                            <p class="font-bold line-clamp-2">
                                                {{ employee.departmentName }}
                                            </p>
                                            <p class="truncate">
                                                {{ employee.jobTitleName }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="w-full h-28 flex justify-center items-center">
                    <ElementsPagination v-model="currentPage" :totalContent="employeeCount" :contentsPerPage="searchJsonQuery.limit" @clickPage="afterClickPage" />
                </div>
            </div>

            <div class="flex justify-center items-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.4142 12L11.7071 11.2929L5.70711 5.29289C5.31658 4.90237 4.68342 4.90237 4.29289 5.29289C3.90237 5.68342 3.90237 6.31658 4.29289 6.70711L9.58579 12L4.29289 17.2929C3.90237 17.6834 3.90237 18.3166 4.29289 18.7071C4.68342 19.0976 5.31658 19.0976 5.70711 18.7071L11.7071 12.7071L12.4142 12Z"
                        fill="#393C47" />
                    <path d="M13 6L19 12L13 18" stroke="#393C47" stroke-width="2" stroke-linecap="round" />
                </svg>
            </div>

            <div>
                <div class="w-full py-10">
                    <div class="w-full h-[1px] bg-[#D9D9D9] relative">
                        <div class="px-5 font-inter-heading-15 text-content-basic-1 bg-[#fff] absolute text-center left-[50%] translate-x-[-50%] top-[-15px] truncate">
                            <template v-if="isTransfer"> Recipient List </template>
                            <template v-if="isDeduct"> Recipient List </template>
                        </div>
                    </div>
                </div>
                <div class="h-[46.75rem] border-[#D6DDEB] border-[1px] rounded-lg overflow-hidden">
                    <div class="h-[4.25rem] flex justify-between items-center bg-[#F8F8F8] border-b-[1px]">
                        <h3 class="px-4 text-base font-medium text-slate-500 w-[3.125rem] text-center">No</h3>
                        <h3 class="py-4 text-base font-medium text-slate-500 w-[12.8125rem] text-left px-4">Name</h3>
                        <h3 class="py-4 text-base font-medium text-slate-500 w-[11.5rem] text-left px-4">
                            Dept. <br />
                            & Tier
                        </h3>
                        <h3 class="py-4 text-base font-medium text-slate-500 w-[10rem] text-center">Point amount*</h3>
                        <h3 class="py-4 text-base font-medium text-slate-500 w-[1.875rem] text-center"></h3>
                    </div>
                    <div class="overflow-auto max-h-[42.5rem]">
                        <div class="min-w-full">
                            <template v-for="(employee, index) in selectedEmployees" v-bind:key="index">
                                <div class="flex justify-between items-center py-2.5 w-full" :class="{ 'bg-slate-50': index % 2 !== 0 }">
                                    <div class="w-[3.125rem] text-sm font-normal text-center truncate">
                                        {{ index + 1 }}
                                    </div>
                                    <div class="w-[12.8125rem] flex items-center gap-2 px-4">
                                        <StatusCircle :status-code="employee.employeeStatus" />
                                        <div class="ml-1 flex-1 text-base font-bold line-clamp-2">
                                            {{ employee.employeeName }}
                                        </div>
                                    </div>
                                    <div class="w-[11.5rem] text-sm font-normal text-left px-4">
                                        <div class="flex-1 text-base leading-5">
                                            <p class="font-bold line-clamp-2">
                                                {{ employee.departmentName }}
                                            </p>
                                            <p class="truncate">
                                                {{ employee.jobTitleName }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-[10rem] px-2 text-sm font-normal text-center truncate">
                                        <ElementsInput v-model="employee.mileageVolumeFormat" placeholder="0" :full="true" @input="onInputMileage($event, employee)" />
                                    </div>
                                    <button @click="clickDeleteButton(index)" class="w-[1.875rem] flex justify-center items-center">
                                        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-4">
                                            <path d="M1.66003 8.00016L8.00003 1.66016" stroke="#E73737" stroke-width="1.68021" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M8.00003 8.00016L1.66003 1.66016" stroke="#E73737" stroke-width="1.68021" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full px-10 py-5">
            <div class="flex flex-col gap-2">
                <div class="font-inter-heading-15 text-content-basic-1 mb-2">Message</div>
                <textarea
                    v-model="transactionMessage"
                    placeholder="Message"
                    maxlength="150"
                    :class="['p-5 outline-0 w-full h-[114px] text-sm rounded-lg bg-white transition-all duration-500 shadow shadow-gray-100', showTransactionMessageError ? 'border-accent-red-3 border' : 'border']" />
                <p v-if="showTransactionMessageError" class="mt-2 font-inter-caption-2 text-accent-red-3">{{ transactionMessageErrorMessage }}</p>
            </div>
        </div>
        <div class="w-full px-10 py-5">
            <div class="font-inter-heading-15 text-content-basic-1">Total</div>
            <div class="mt-4 flex items-baseline gap-16">
                <div class="flex items-baseline gap-3">
                    <span class="font-inter-heading-19 text-content-basic-1">Employees</span>
                    <span class="font-inter-heading-19 text-primary-3">{{ selectedEmployees.length || '-' }}</span>
                </div>
                <div class="flex items-baseline gap-3">
                    <span class="font-inter-heading-19 text-content-basic-1">Total Points</span>
                    <span class="font-inter-heading-19 text-primary-3">{{ totalAmount > 0 ? numberWithCommas(totalAmount) : '-' }}</span>
                </div>
            </div>

            <button @click="clickTransferButton" v-if="isTransfer" class="rounded-[12px] mt-8 w-full text-center text-[#fff] h-[62px] leading-[62px] bg-[#4640DE]">
                Transfer
            </button>
            <button @click="clickDeductButton" v-if="isDeduct" class="rounded-[12px] mt-8 w-full text-center text-[#fff] h-[62px] leading-[62px] bg-[#4640DE]">
                Deduct
            </button>
        </div>
    </div>

    <Teleport to="body">
        <DesignConfirmPopup
            v-model="showAlertPopup"
            :showTitle="true"
            title="Failed"
            :confirmDescription="alertMessage"
            buttonText="OK"
            confirmBtnType="RED_SOLID"
            :showCancel="false"
        />
        <DesignConfirmPopup
            v-model="showConfirmPopup"
            :showTitle="true"
            title="Confirm"
            :confirmDescription="confirmMessage"
            buttonText="Confirm"
            :showCancel="true"
            cancelText="Cancel"
            :hasAfterConfirm="true"
            @after-confirm="clickSubmit"
        />
    </Teleport>
</template>

<script>
import ElementsPagination from '@/components/elements/ElementsPagination.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignConfirmPopup from '@/components/design-system/design-confirm-popup.vue';
import StatusCircle from '@/components/employee/status-circle/status-circle';

export default {
    components: {
        ElementsPagination,
        DesignDropdownSelect,
        DesignConfirmPopup,
        StatusCircle,
    },
    props: {
        transactionType: String,
    },
    emits: ['clickTransferButton', 'clickDeductButton'],
    data() {
        return {
            walletCategoryOptions: [],
            selectedWalletCategorySeq: null,
            selectedWalletCategoryName: null,
            showWalletCategoryError: false,
            walletCategoryErrorMessage: 'Please select a wallet.',

            employees: [],
            selectedEmployees: [],

            currentPage: null,
            employeeCount: null,
            AccEmployeeCount: null,

            searchedText: null,
            searchedValues: null,

            availableWalletAmount: 0,
            subAdminAvailableMileage: null,
            searchJsonQuery: {
                limit: 10,
                offset: null,
                employeeSeqList: null,
                departmentSeq: null,
                jobTitleSeq: null,
            },

            searchInputStr: null,
            departmentOptions: [],
            jobTitleOptions: [],
            subAdminOptions: [],
            employeePlaceholer: 'Search Employees',

            totalAmount: 0,
            transactionMessage: '',
            showTransactionMessageError: false,
            transactionMessageErrorMessage: 'Please provide a message to display.',

            alertMessage: '',
            confirmMessage: '',
            showAlertPopup: false,
            showConfirmPopup: false,

            scrollYBackup: 0,


        };
    },
    computed: {
        // 여기에 모달이 더 있으면 || 로 추가
        isAnyPopupOpen() {
            return this.showAlertPopup || this.showConfirmPopup;
        },
        isTransfer() {
            return (this.transactionType ? this.transactionType === 'transfer' : !!this.transfer);
        },
        isDeduct() {
            return (this.transactionType ? this.transactionType === 'deduct' : !!this.deduct);
        },
    },
    watch: {
        isAnyPopupOpen(val) {
            if (val) {
                this.lockBodyScroll();
            } else {
                this.unlockBodyScroll();
            }
        },
        // 부모의 트랜잭션 타입 변경 감지
        transactionType() {
            this.handleTypeChange();
        },
        // 지갑 카테고리 선택 변경 시 메서드 실행
        selectedWalletCategorySeq(newVal) {
            this.handleWalletCategoryChange(newVal);
        },
    },
    mounted() {
        this.getWalletCategoryList();
        this.getAvailablePoint();
        this.getEmployeesListData(true);
        this.getSubAdminOptions();
        this.getDepartmentOptions();
        this.getJobTitleOptions();
    },
    methods: {
        handleTypeChange() {
            // 타입 변경 시 입력값 초기화
            this.transactionMessage = '';
            this.selectedWalletCategorySeq = null;
            this.selectedWalletCategoryName = null;
            this.selectedEmployees = [];
            this.totalAmount = 0;
            this.AccEmployeeCount = 0;
            this.currentPage = 1;
            this.initValidationErrors();
            this.getEmployeesListData(true, 0);
        },
        initValidationErrors() {
            this.showTransactionMessageError = false;
            this.showWalletCategoryError = false;
        },
        lockBodyScroll() {
            // 현재 스크롤 위치 저장
            this.scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;

            // 레이아웃 점프 방지 및 스크롤 잠금
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollYBackup}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden'; // 보조(데스크톱)
        },
        unlockBodyScroll() {
            // 원복
            const y = this.scrollYBackup || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 저장해 둔 위치로 복귀
            window.scrollTo(0, y);
        },
        over20Charaters(word) {
            if (!word) return word;

            if (word.length < 21) return word;
            return word.substring(0, 20) + '...';
        },
        getWalletCategoryList() {
            const self = this;
            const url = self.$api('uri', 'get-wallet-category-list');
            self.$axios
                .get(url)
                .then((res) => {
                    self.walletCategoryOptions = res.data.data.list.map((wallet) => ({ text: wallet.walletCategoryName, value: wallet.walletCategorySeq }));
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        onWalletCategoryChange() {
            // 템플릿 change 이벤트에서 호출: 현재 선택값으로 처리
            this.handleWalletCategoryChange(this.selectedWalletCategorySeq);
        },
        handleWalletCategoryChange(rawValue) {
            // change 핸들러와 watcher 양쪽에서 호출됨
            // option 객체 혹은 단일 값 모두 허용
            const value = (rawValue && typeof rawValue === 'object')
                ? (rawValue.value != null ? rawValue.value : this.selectedWalletCategorySeq)
                : (rawValue != null ? rawValue : this.selectedWalletCategorySeq);

            // 유효성 표시 제거 및 선택된 이름 동기화
            this.showWalletCategoryError = false;
            this.selectedWalletCategoryName = (this.walletCategoryOptions || [])
                .find(o => o?.value === value)?.text || null;
            if (value) {
                this.fetchSubAdminTotalMileage(value);
            } else {
                this.subAdminAvailableMileage = null;
            }
        },
        fetchSubAdminTotalMileage(walletCategorySeq) {
            const url = this.$api('uri', 'get-wallet-subadmin-total-mileage').replace('{walletCategorySeq}', walletCategorySeq);
            this.$axios
                .get(url)
                .then((res) => {
                    const v = res.data?.data;
                    this.subAdminAvailableMileage = Number(v) || 0;
                })
                .catch((err) => {
                    console.error('fetchSubAdminTotalMileage error', err);
                    this.subAdminAvailableMileage = null;
                });
        },
        getAvailablePoint() {
            const url = this.$api('uri', 'get-availablePoint');
            this.$axios
                .get(url)
                .then((res) => {
                    this.availableWalletAmount = res.data.data.availableWalletAmount;
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        getDepartmentOptions() {
            const url = this.$api('uri', 'get-department');
            const json_query = JSON.stringify({
                showRootNode: true
            });
            this.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((dep) => ({
                    text: dep.departmentName,
                    value: dep.departmentSeq,
                }));

                this.departmentOptions.push(...options);
            });
        },
        getJobTitleOptions() {
            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });
            const url = this.$api('uri', 'get-jobTitle');
            this.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((title) => ({ text: title.jobTitleName, value: title.jobTitleSeq }));
                this.jobTitleOptions.push(...options);
            });
        },
        // removed getEmployeeOptions; using getSubAdminOptions instead
        getSubAdminOptions() {
            const url = this.$api('uri', 'get-sub-admin-list');
            this.$axios
                .get(url, { params: { limit: -1, offset: 0 } })
                .then((res) => {
                    const list = res.data?.data?.list || [];
                    this.subAdminOptions = list.map(sa => ({ text: sa.subAdminName, value: sa.subAdminSeq }));
                })
                .catch((err) => {
                    console.error('getSubAdminOptions err : ', err);
                });
        },
        getEmployeesListData(isInit = false, offset = 0) {
            this.searchJsonQuery.offset = offset;

            if (offset == 0) {
                this.searchedText = this.$refs.employeeSearchBar.getSearchedText();
                this.searchedValues = this.$refs.employeeSearchBar.getSearchedValues();
            } else {
                this.$refs.employeeSearchBar.setInputText(this.searchedText);
            }

            const url = this.$api('uri', 'get-sub-admin-list');
            const params = {
                limit: this.searchJsonQuery.limit,
                offset: this.searchJsonQuery.offset || 0,
            };
            if ((this.searchedText || '').trim().length > 0) {
                params.searchName = this.searchedText.trim();
            }

            this.$axios
                .get(url, { params })
                .then((res) => {
                    const list = res.data?.data?.list || [];
                    // Sub-admin 응답을 현재 UI에서 사용하는 필드명으로 매핑
                    this.employees = list.map((sa) => ({
                        subAdminSeq: sa.subAdminSeq,
                        employeeSeq: sa.employeeSeq,
                        employeeName: sa.subAdminName,
                        departmentName: sa.subAdminDepartmentName,
                        jobTitleName: sa.subAdminJobTitle,
                        email: sa.subAdminEmail || null,
                        employeeStatus: 'ACTIVE',
                    }));
                    this.employeeCount = list.length;
                })
                .catch((err) => {
                    console.error('getSubAdmin list err : ', err);
                });
        },
        afterClickPage(item) {
            //for employee no 누적
            this.AccEmployeeCount = item;
            this.getEmployeesListData(false, item);
        },
        searchEmployeeData() {
            this.AccEmployeeCount = 0;
            this.currentPage = 1;
            this.getEmployeesListData(true, 0);
        },
        clickAddButton(selectEmp) {
            //중복일경우
            if (this.selectedEmployees.some((emp) => emp.employeeSeq == selectEmp.employeeSeq)) return;

            //10명이상을 선택할 경우
            if (this.selectedEmployees.length >= 10) {
                
                this.openAlertPopup('You can only select up to 10 people.');
                return;
            }

            this.selectedEmployees.push(selectEmp);
        },
        clickDeleteButton(index) {
            this.selectedEmployees.splice(index, 1);
            this.calTotalAmount();
        },
        clickSubmit() {
            this.hideConfirmPopup();

            if (this.isTransfer) {
                this.submitTransfer();
            } else if (this.isDeduct) {
                this.submitDeduct();
            }
        },
        submitTransfer() {
            const subAdminTransactionForms = this.selectedEmployees.map(emp => ({
                companySeq: emp.companySeq,
                subAdminSeq: emp.subAdminSeq,
                employeeSeq: emp.employeeSeq,
                employeeName: emp.employeeName,
                employeeEmail: emp.email,
                mileageVolume: Number(emp.mileageVolume || 0),
                transactionNote: (emp.transactionNote || '').trim(),
            }));

            const transferForm = {
                subAdminTransactionForms,
                walletCategorySeq: this.selectedWalletCategorySeq,
                walletCategoryName: (this.walletCategoryOptions || []).find(o => o?.value === this.selectedWalletCategorySeq)?.text || '',
                transactionNote: (this.transactionMessage || '').trim(),
                totalPersonCount: this.selectedEmployees.length,
                totalMileageVolume: this.totalAmount,
            };

            this.$emit('clickTransferButton', transferForm);
        },
        clickTransferButton() {
            if (this.checkValidation() != 0) {
                return;
            }

            // total amount 가 가지고 있는 것보다 큰 경우
            if (this.totalAmount > this.availableWalletAmount) {
                this.openAlertPopup('The amount of transfer is more than total');
                return;
            }

            this.openConfirmPopup('Are you sure you want to transfer points?');
        },
        submitDeduct() {
            const subAdminTransactionForms = this.selectedEmployees.map(emp => ({
                companySeq: emp.companySeq,
                subAdminSeq: emp.subAdminSeq,
                employeeSeq: emp.employeeSeq,
                employeeName: emp.employeeName,
                employeeEmail: emp.email,
                mileageVolume: Number(emp.mileageVolume || 0),
            }));

            const deductForm = {
                subAdminTransactionForms,
                walletCategorySeq: this.selectedWalletCategorySeq,
                walletCategoryName: (this.walletCategoryOptions || []).find(o => o?.value === this.selectedWalletCategorySeq)?.text || '',
                transactionNote: (this.transactionMessage || '').trim(),
                totalPersonCount: this.selectedEmployees.length,
                totalMileageVolume: this.totalAmount,
            };

            this.$emit('clickDeductButton', deductForm);
        },
        clickDeductButton() {
            this.hideConfirmPopup();

            if (this.checkValidation() != 0) {
                return;
            }

            this.openConfirmPopup('Are you sure you want to deduct points?');
        },
        onInputMileage(event, employee) {
            const input = event.target.value;
            // 숫자만 추출하고, 앞자리 0 제거
            const mileage = input.replace(/[^0-9]/g, '').replace(/^0+(?!$)/, '');

            employee.mileageVolume = mileage;
            employee.mileageVolumeFormat = this.numberWithCommas(mileage);

            this.calTotalAmount();
        },
        calTotalAmount() {
            if (this.selectedEmployees.length == 0) {
                this.totalAmount = 0;
                return this.totalAmount;
            }
            let sum = 0;
            this.selectedEmployees.forEach((employee) => {
                const points = Number(employee.mileageVolume);
                sum += points;
            });
            this.totalAmount = sum;
            return this.totalAmount;
        },
        checkValidation() {
            this.initValidationErrors();

            if ((this.transactionMessage || '').trim().length === 0) {
                this.showTransactionMessageError = true;
            }

            if (!this.selectedWalletCategorySeq) {
                this.showWalletCategoryError = true;
            }

            if (this.showTransactionMessageError || this.showWalletCategoryError) {
                this.isTransfer? 
                this.openAlertPopup('Transfer failed due to an invalid input. Please check and try again.')
                :this.openAlertPopup('Deduct failed due to an invalid input. Please check and try again.');

                return 1;
            }

            //validation ---------------------------------------------------------------------------------
            //중복 값 제거
            let validationCnt = 0;
            this.selectedEmployees = this.selectedEmployees.filter((character, idx) => {
                if (character.email == null || '') return;
                return this.selectedEmployees.findIndex((item) => item.email == character.email) === idx;
            });

            //mileageVolume 에 정수 외의 값을 입력했을 경우
            this.selectedEmployees.forEach((employee) => {
                const points = Number(employee.mileageVolume);
                if (Number.isNaN(points) || points < 1) {
                    validationCnt++;
                }
            });

            if (validationCnt > 0) {
                this.openAlertPopup('You need to enter the point amount.');
                return validationCnt++;
            }

            //아무도 선택하지 않았을 경우
            if (this.selectedEmployees.length == 0) {
                this.openAlertPopup('Please select at least one employee.');
                validationCnt++;
            }

            if (validationCnt > 0) return validationCnt;

            this.calTotalAmount();
            return validationCnt;
        },
        numberWithCommas(number) {
            if (!number) {
                return 0;
            }
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        openAlertPopup(message) {
            this.alertMessage = message;
            this.showAlertPopup = true;
        },
        hideAlertPopup() {
            this.showAlertPopup = false;
        },
        openConfirmPopup(message) {
            this.confirmMessage = message;
            this.showConfirmPopup = true;
        },
        hideConfirmPopup() {
            this.showConfirmPopup = false;
        },
    },
};
</script>
